import React from "react";
import { getMaxCycles, getMaxLength } from "../functions";
import { range } from "../../../../utilities/generators";
import { Grid, TextField } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import PropTypes from "prop-types";


const getLabel = (singular, value) => (value === 1 ? `1 ${singular}` : `${value} ${singular}s`);

function RepeatCycle({ type, length, setLength, cycles, setCycles }) {
    if (type === 'never') return null;

    const handleSetLength = (event) => { setLength(Number(event.target.value)); }
    const handleSetCycles = (event) => { setCycles(Number(event.target.value)); }

    const maxLength = getMaxLength(type);
    const maxCycles = getMaxCycles(length, maxLength);

    const lengthRange = range(1, maxLength);
    const cycleRange = maxCycles > 0 ? range(1, maxCycles) : [];
    const label = (type === 'weekly' ? 'week' : 'month');
    const currentLength = (!!length && length <= maxLength ? length : '');
    const currentCycles = (!!cycles && cycles <= maxCycles ? cycles : '');

    return (
        <React.Fragment>
            <Grid item xs={4} sm={4} md={4}>
                <TextField
                    variant="outlined"
                    id="select-repeat-every"
                    select
                    label="Every"
                    helperText="cycle length"
                    value={currentLength}
                    onChange={handleSetLength}
                >
                    {lengthRange.map((option) => (
                        <MenuItem key={option} value={option}>
                            {getLabel(label, option)}
                        </MenuItem>
                    ))}
                </TextField>

            </Grid>

            <Grid item xs={4} sm={4} md={4}>
                <TextField
                    variant="outlined"
                    id="select-repeat-for"
                    select
                    label="For"
                    helperText="maximum cycles"
                    value={currentCycles}
                    onChange={handleSetCycles}
                >
                    {cycleRange.map((option) => (
                        <MenuItem key={option} value={option}>
                            {option}
                        </MenuItem>
                    ))}
                </TextField>

            </Grid>
        </React.Fragment>
    )
}

RepeatCycle.propTypes = {
    type: PropTypes.string.isRequired,
    length: PropTypes.number, // will treat 0 as ''
    setLength: PropTypes.func.isRequired,
    cycles: PropTypes.number, // will treat 0 as ''
    setCycles: PropTypes.func.isRequired,
}

export default RepeatCycle;
